import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'app/_services/loader.service';
import { environment } from 'environments/environment';
import { HttpClient } from "@angular/common/http";


import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import * as _ from "lodash";
import { AuthService } from 'app/_services';
import { Observable, Subscription } from 'rxjs';

import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';



const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};
declare var $: any;
declare var google: any;
declare var firebase: any;
declare var MapLabel: any;
var stopAnimation = true;

declare const MarkerClusterer;

@Component({
  selector: 'mapdashboard',
  templateUrl: './maptrackerDashboard.component.html',
  styleUrls: ['./maptrackerDashboard.component.css']
})
export class maptrackerDashboardComponent implements OnInit {

  map: any
  countData: any;
  showLoader: any;
  prjID: string;
  public date = moment();
  authtoken: any;


 

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  vehiclesData: any[];


  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.vehiclesData
    };
    return result;
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  private loadProducts(): void {
    this.gridinventory = process(this.vehiclesData, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private loaderService: LoaderService,
    private auth: AuthService,
    private http: HttpClient
  ) { 
    this.authtoken = JSON.parse(localStorage.getItem('authData'));
    this.prjID = this.auth.getAuthentication().projectId;
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });



  }

  ngOnInit() {
   
    var authData = JSON.parse(localStorage.getItem('authData'))

  }



}



// WEBPACK FOOTER //
// ./src/app/maptracker/maptracker-dashboard/maptrackerDashboard.component.ts